
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { WeightInputProps } from "./types";

export function WeightInput({ weight, setWeight }: WeightInputProps) {
  return (
    <div>
      <Label htmlFor="weight" className="mb-2 block card-label">Peso (grammi)</Label>
      <Input
        id="weight"
        type="number"
        min="1"
        max="100000"
        value={weight}
        onChange={(e) => setWeight(e.target.value)}
        className="w-full"
      />
      <p className="text-xs text-muted-foreground mt-1">
        Min: 1g, Max: 100kg
      </p>
    </div>
  );
}
